import { COLECAO_GDM_TESTE, mintGdmDeTeste, numeroDoMintGdm, perfilGdm, type PerfilGdm } from './gdm-pontos'
import { DADOS_GDM_TESTE } from './gdm-teste-dados'
import { tacoDeNft, type TacoEmJogo } from './taco-em-jogo'

/**
 * Tacos de TESTE da Gangue do Macaco: os NFTs que já têm arte gerada, com
 * raridade e atributos tirados dos traits reais (`scripts/colecoes/perfis-gdm.ts`).
 *
 * Servem para ver a arte e sentir os atributos antes de a coleção entrar de
 * verdade — no seletor do lobby com `TACOS_LIBERADOS` e no treino. Não são
 * posse de ninguém: o mint é inventado e a coleção, `GDM-TESTE`.
 *
 * Os PONTOS não saem do ruleset nem de classe: ver `gdm-pontos.ts`.
 *
 * A arte é POR NFT, não por arquétipo e raridade como na coleção própria: é
 * a diferença que faz um taco de coleção parceira ser o taco daquele macaco.
 */

export const skinGdm = (numero: number): string => `/tacos/gdm/${numero}.png`

/**
 * A arte pequena, para LISTA: o cartão da janela "Seus tacos", o taco em uso no
 * lobby e o menu de treino.
 *
 * A arte cheia tem 1488 px e ~120 KB; doze cartões numa página baixavam ~1,4 MB
 * para desenhar alguns centímetros. A miniatura tem 256 px e ~8 KB — a mesma
 * página cabe em ~95 KB. O visor continua com a arte cheia: lá ela é o assunto.
 *
 * Gerada por `scripts/miniaturas-taco.ts`. Se faltar, o cartão cai na arte
 * cheia pelo `onerror` — pesa, mas nunca some.
 */
export const miniaturaGdm = (numero: number): string => `/tacos/gdm/mini/${numero}.png`

/**
 * A miniatura de um taco da GDM, ou a arte dele mesmo se não for um.
 *
 * A arte de uma coleção PARCEIRA é servida por hash (`/artes/tacos/<sha>.png`)
 * e ainda não tem miniatura: para ela isto devolve a própria arte. Ver a dívida
 * no `ONDE-PARAMOS`.
 */
export const artePequenaDoTaco = (skin: string): string => {
  const m = /^\/tacos\/gdm\/(\d+)\.png$/.exec(skin)
  return m ? miniaturaGdm(Number(m[1])) : skin
}

/**
 * O perfil que o modelo de taco pede vem de `gdm-pontos` — é o MESMO que
 * alimenta os pontos, e duas cópias poderiam discordar da seed.
 */
export { perfilGdm }

export const tacoGdmDeTeste = (p: PerfilGdm): TacoEmJogo => ({
  ...tacoDeNft(mintGdmDeTeste(p.numero), COLECAO_GDM_TESTE, perfilGdm(p)),
  skin: skinGdm(p.numero),
})

/** O nome do taco na tela, "GDM Taco #461", ou nulo se não for um taco de teste da GDM. */
export function nomeDoTacoGdm(t: TacoEmJogo): string | null {
  if (t.origem !== 'nft' || t.colecao !== COLECAO_GDM_TESTE) return null
  const n = numeroDoMintGdm(t.mint)
  return n === null ? null : `GDM Taco #${n}`
}

export const TACOS_GDM_TESTE: readonly PerfilGdm[] = DADOS_GDM_TESTE
